// NO EDITAR A MANO
// const id = "footer.link_apps.url-ios-pro";
const valor = `https://itunes.apple.com/es/app/tiempo.com/id1106389686?mt=8&pt=1244240&ct=meteoredcom`;

export default valor;
